var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 469,
    viewBox: "0 0 469 557",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_502_518)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29 480L16.5 352L2 353.5L1 339L94 257L322 235L429.5 298L431 312L416.5 313.5L428.5 441.5L29 480Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.094 247.976L322.135 234.951L338.123 244.335V202.816L261.872 126.482L185.622 202.816V249.206L187.094 247.976Z",
    fill: "#D7CDE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.621 465.105V503.092C205.848 482.857 233.273 471.491 261.867 471.491C290.462 471.491 317.887 482.857 338.114 503.092V450.406L185.621 465.105Z",
    fill: "#D7CDE0"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_502_518)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M386.872 98.3398C451.943 65.7607 432.025 0.602539 386.872 0.602539C341.718 0.602539 321.809 65.7858 386.872 98.3398Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M386.872 98.3398C451.943 65.7607 432.025 0.602539 386.872 0.602539C341.718 0.602539 321.809 65.7858 386.872 98.3398Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.69 100.851L384.99 99.4785C385.56 99.1379 386.212 98.958 386.875 98.958C387.539 98.958 388.191 99.1379 388.761 99.4785L391.052 100.851",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.872 99.5029V190.301C386.876 215.828 382.637 241.177 374.329 265.311",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.711 305.813L351.955 329.143L310.764 333.114L308.52 309.783C307.993 304.314 309.659 298.859 313.15 294.62C316.642 290.38 321.672 287.702 327.136 287.175C332.598 286.651 338.045 288.32 342.278 291.815C346.512 295.31 349.185 300.345 349.711 305.813Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M327.16 287.218C326.136 287.324 325.121 287.508 324.125 287.77C329.07 288.03 333.757 290.058 337.334 293.485C340.911 296.913 343.14 301.512 343.616 306.446L345.865 329.775L351.986 329.189L349.745 305.851C349.218 300.382 346.543 295.346 342.308 291.852C338.072 288.358 332.623 286.691 327.16 287.218Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1552 430.945L53.3389 380.904L108.459 375.589L113.276 425.629",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1552 430.945L53.3389 380.904L108.459 375.589L113.276 425.629",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M108.422 375.614L53.2969 380.928L54.2802 391.151L109.405 385.838L108.422 375.614Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.856 420.749L159.04 370.717L214.169 365.401L218.977 415.442",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.856 420.749L159.04 370.717L214.169 365.401L218.977 415.442",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M214.123 365.435L158.998 370.749L159.981 380.973L215.106 375.659L214.123 365.435Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.135 234.951L93.8852 256.958L0.627075 339.226",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.135 234.951L93.8852 256.958L0.627075 339.226",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.279 438.144L14.3232 481.621",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.106 458.208L243.777 319.613",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.201 303.089L428.53 441.684",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8559 480.215L16.5391 352.15",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 352L29 480L428.5 441.5L416 313.5L430.5 312",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.402 348.128L303.125 353.938L311.072 436.561L371.349 430.751L363.402 348.128Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.898 421.151L159.04 370.717L214.169 365.401L219.019 415.835",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1887 431.338L53.3389 380.904L108.459 375.589L113.317 426.023",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.601 454.768C291.918 447.67 289.235 440.913 284.867 435.281L282.308 431.983C278.862 427.279 274.249 423.558 268.925 421.189C263.602 418.819 257.752 417.883 251.955 418.472C245.222 419.138 239.028 422.449 234.73 427.68C230.43 432.912 224.232 436.224 217.496 436.888L214.654 437.19C208.085 437.851 202.042 441.078 197.834 446.171C193.626 451.263 191.594 457.811 192.177 464.395L292.601 454.768Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.25 433.624L333.298 351.004",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.536 429.869L301.89 437.45L303.461 453.781L382.107 446.201L380.536 429.869Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.712 305.813L351.956 329.143L310.764 333.113L308.52 309.783C307.994 304.314 309.66 298.859 313.151 294.619C316.642 290.38 321.673 287.702 327.136 287.175V287.175C332.6 286.649 338.048 288.316 342.284 291.811C346.519 295.306 349.194 300.342 349.72 305.812L349.712 305.813Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.745 305.851L351.986 329.189L372.581 327.197L368.358 283.25C365.653 283.51 363.026 284.301 360.627 285.578C358.228 286.855 356.103 288.592 354.375 290.691C352.646 292.79 351.348 295.209 350.553 297.81C349.759 300.411 349.484 303.144 349.745 305.851V305.851Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.97 291.194L290.193 335.141L310.796 333.157L308.547 309.827C308.287 307.12 307.497 304.49 306.222 302.088C304.947 299.686 303.211 297.559 301.115 295.829C299.018 294.099 296.602 292.799 294.003 292.004C291.405 291.208 288.675 290.933 285.97 291.194V291.194Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.233 388.111L467.905 379.74C468.47 377.019 468.49 374.212 467.963 371.483C467.436 368.754 466.374 366.157 464.837 363.842C463.3 361.527 461.319 359.541 459.009 357.998C456.7 356.455 454.107 355.386 451.382 354.854C450.797 348.674 448.556 342.767 444.894 337.757C441.232 332.747 436.286 328.821 430.578 326.393C426.323 324.577 421.643 323.996 417.073 324.719C412.504 325.441 408.23 327.437 404.741 330.478L403.629 331.491C396.049 338.113 390.157 346.451 386.442 355.811C382.728 365.17 381.298 375.283 382.273 385.307C382.764 390.477 384.274 395.498 386.713 400.081C389.153 404.664 392.475 408.718 396.488 412.01C404.914 418.937 415.735 422.247 426.59 421.217L429.884 420.899C438.648 420.042 446.907 416.394 453.449 410.493C459.99 404.592 464.471 396.748 466.233 388.111Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.639 421.209L422.751 381.632",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.564 421.217C426.564 421.217 420.385 391.627 400.016 393.594",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.106 395.729C437.293 394.456 447.519 384.085 447.519 384.085",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M451.398 354.888C450.814 348.708 448.572 342.801 444.91 337.791C441.248 332.781 436.302 328.855 430.594 326.427C424.866 323.959 418.412 323.77 412.55 325.9C414.579 326.227 416.563 326.788 418.462 327.574C424.154 330.023 429.086 333.955 432.745 338.961C436.404 343.966 438.656 349.862 439.266 356.035C441.989 356.572 444.579 357.644 446.886 359.189C449.194 360.734 451.172 362.721 452.709 365.035C454.245 367.35 455.308 369.946 455.836 372.674C456.365 375.402 456.349 378.208 455.788 380.929L454.116 389.3C452.501 397.19 448.61 404.432 442.925 410.13C437.241 415.829 430.011 419.733 422.132 421.36C423.615 421.371 425.097 421.304 426.572 421.159L429.867 420.841C438.623 419.986 446.877 416.349 453.423 410.464C459.968 404.579 464.462 396.752 466.249 388.128L467.921 379.757C468.484 377.037 468.501 374.232 467.973 371.505C467.445 368.778 466.382 366.183 464.846 363.87C463.309 361.557 461.329 359.572 459.021 358.03C456.713 356.488 454.122 355.42 451.398 354.888Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.233 388.111L467.905 379.74C468.47 377.019 468.49 374.212 467.963 371.483C467.436 368.754 466.374 366.157 464.837 363.842C463.3 361.527 461.319 359.541 459.009 357.998C456.7 356.455 454.107 355.386 451.382 354.854C450.797 348.674 448.556 342.767 444.894 337.757C441.232 332.747 436.286 328.821 430.578 326.393C426.323 324.577 421.643 323.996 417.073 324.719C412.504 325.441 408.23 327.437 404.741 330.478L403.629 331.491C396.049 338.113 390.157 346.451 386.442 355.811C382.728 365.17 381.298 375.283 382.273 385.307C382.764 390.477 384.274 395.498 386.713 400.081C389.153 404.664 392.475 408.718 396.488 412.01C404.914 418.937 415.735 422.247 426.59 421.217L429.884 420.899C438.648 420.042 446.907 416.394 453.449 410.493C459.99 404.592 464.471 396.748 466.233 388.111Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.135 234.951L429.365 297.891L430.745 312.213L416.212 313.611L415.201 303.089L323.515 249.274L230.256 331.542L2.00676 353.548L0.627075 339.226",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.769 421.737L225.139 415.241",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0684 431.932L119.439 425.437",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M0.627075 339.226L228.693 317.236L322.135 234.951L429.365 297.891L430.745 312.213L416.212 313.611L415.201 303.089L323.515 249.274L231.168 332.747L2.00676 353.548L0.627075 339.226Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_502_518)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.7237 132.97C5.65291 100.391 25.5705 35.2324 70.7237 35.2324C115.877 35.2324 135.811 100.391 70.7237 132.97Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70.7237 132.97C5.65291 100.391 25.5705 35.2324 70.7237 35.2324C115.877 35.2324 135.811 100.391 70.7237 132.97Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9047 135.481L72.6136 134.1C72.0422 133.758 71.3892 133.578 70.7238 133.578C70.0584 133.578 69.4054 133.758 68.8341 134.1L66.543 135.481",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7236 134.1V191.423C70.7163 216.947 74.9551 242.295 83.2662 266.425",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M225.382 557C330.188 557 415.151 551.513 415.151 544.745C415.151 537.977 330.188 532.49 225.382 532.49C120.575 532.49 35.6125 537.977 35.6125 544.745C35.6125 551.513 120.575 557 225.382 557Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_502_518",
    x: 344.459,
    y: -0.147461,
    width: 84.8296,
    height: 99.3257,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -10,
    dy: -5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.839216 0 0 0 0 0.839216 0 0 0 0 0.839216 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_502_518"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_502_518",
    x: 28.3073,
    y: 34.4824,
    width: 84.8398,
    height: 99.3262,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -10,
    dy: -5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.839216 0 0 0 0 0.839216 0 0 0 0 0.839216 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_502_518"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_502_518"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 469,
    height: 557,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/House.8beeed41317d20d73fdf33e6a040813b.svg";
export { ForwardRef as ReactComponent };